// src/api/wish.js
import request from '@/lin/plugin/axios'

// 发布愿望
export function publishWish(data) {
  return request({
    url: '/v1/front/wish',
    method: 'post',
    data
  })
}

// 获取随机许愿
export function getRandomWishes() {
  return request({
    url: '/v1/front/wish/random',
    method: 'get'
  })
}

// 获取愿望详情
export function getWishDetail(id) {
  return request({
    url: `/v1/front/wish/${id}`,
    method: 'get'
  })
}

// 更新愿望
export function updateWish(id, data) {
  return request({
    url: `/v1/front/wish/${id}`,
    method: 'put',
    data
  })
}

// 删除愿望
export function deleteWish(id) {
  return request({
    url: `/v1/front/wish/${id}`,
    method: 'delete'
  })
}
